<template>
  <div class="my-order">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:15px">
        <p class="account-card-title">我的资金账户</p>
      </div>
      <!--账户内容开始-->
      <el-form
        class="order-form"
        :inline="true"
        :model="form"
        ref="ruleForm"
        label-width="110px"
      >
        <template v-if="form.accountStatus == 'not'">
          <el-row>
            <el-form-item label="温馨提示：">
              <span
                >贵公司暂未开通在线支付功能，请到会员中心开通在线支付功能。</span
              >
            </el-form-item>
          </el-row>
        </template>
        <template v-if="form.accountStatus != 'not'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="form-item-box"
                label="资金总额："
                prop="total"
              >
                <span>￥{{ form.total }}元</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="120px"
                class="form-item-box"
                label="冻结金额："
                prop="frozen"
              >
                <span>￥{{ form.frozen }}元</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-form-item
              class="form-item-box"
              label="可用余额："
              prop="usable"
            >
              <span>￥{{ form.usable }}元</span>
            </el-form-item>
          </el-row>

          <!-- <el-row>
            <div class="label-item">
              <el-link type="primary" @click="backToLoan">查看货款记录</el-link>
            </div>
          </el-row> -->
          <el-row>
            <el-form-item label="温馨提示：">
              <span>竞买过程中有足够的可用余额可提高竞买效率。</span>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <div class="label-item">
              <el-link type="primary" @click="backToHandBook"
                >查看充值操作手册</el-link
              >
            </div>
          </el-row> -->
        </template>
      </el-form>
      <MyDepositLoan
        v-if="form.accountStatus == 'auth'"
        typeForm="myDepositLoanseller"
      />
      <!--账户内容结束-->
    </div>
  </div>
</template>

<script>
import MyDepositLoan from '../../account/myDeposit/MyDepositLoan.vue'
export default {
  name: 'MyAccount',
  components: { MyDepositLoan },
  directives: {},
  filters: {},
  mixins: {},
  data() {
    return {
      form: {
        total: '',
        usable: '',
        frozen: '',
        dealDateEnd: '',
        compName: '',
        compCode: '',
        accountStatus: ''
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getAccountInfo()
  },
  methods: {
    backToDeposit() {
      this.$router.push({ name: 'MyDepositRecord' })
    },
    backToLoan() {
      this.$router.push({
        name: 'myDepositLoanseller',
        query: { type: 'myDepositLoanseller' }
      })
    },
    async getAccountInfo() {
      this.form = await this.$api.depositPrice.getAccountInfo()
    },
    backToHandBook() {}
  }
}
</script>
<style lang="less" scoped>
.el-form-item .form-item-box {
  width: 100%;
  display: flex;
  .el-form-item__content {
    flex: 1;
  }
}
.label-item {
  margin: 10px 0;
}
::v-deep .el-form-item {
  margin-bottom: 10px !important;
}
</style>
